import { r as u, B as l, n as c } from "./abstract-base-CdeHT0x1.js";
import { g as f } from "./uid-HAKIZOcY.js";
var p = Object.defineProperty, n = (o, t, i, e) => {
  for (var r = void 0, a = o.length - 1, s; a >= 0; a--)
    (s = o[a]) && (r = s(t, i, r) || r);
  return r && p(t, i, r), r;
};
const g = "beacon-table";
class d extends l {
  constructor() {
    super(...arguments), this.deferrable = !0, this.isOriginal = !0, this.uuid = f();
  }
  /** When using transformed cards, this stores all nodes associated with the current one via their identical UUID. */
  get pairedNodes() {
    const { beaconTagName: t, uuid: i } = this, e = `[uuid="${i}"]`, r = `${this.getScopedTagName(t)}${e}`;
    if (this.isOriginal) {
      const a = this.closest(
        this.getScopedTagName(g)
      );
      if (!a) return;
      const s = a._transformedCardsContainer;
      return s ? Array.from(s.querySelectorAll(r)) : void 0;
    }
    return Array.from(document.querySelectorAll(r));
  }
  willUpdate(t) {
    t.forEach((i, e) => {
      this.pairedNodes && e !== "isOriginal" && (!this.isOriginal && e === "bold" || this.pairedNodes.forEach((r) => {
        e && (r[e] = i);
      }));
    });
  }
}
n([
  u()
], d.prototype, "isOriginal");
n([
  c({ reflect: !0 })
], d.prototype, "uuid");
export {
  d as B
};
